import axios from "axios";

/**
 * URL de base pour les appels API.
 * - VITE_API_URL défini : l'utiliser (dev Vite, override explicite).
 * - VITE_API_URL absent/vide (ex. Docker) : origine + "/api" pour que Nginx route
 *   /api/* vers le backend et /* vers le SPA.
 */
const BASE_URL = import.meta.env.VITE_API_URL || `${window.location.origin}/api`;

const defaultHeaders: Record<string, string> = {
  "Content-Type": "application/json",
  Accept: "application/json",
};
if (window.location.hostname.includes("ngrok")) {
  defaultHeaders["ngrok-skip-browser-warning"] = "1";
}

export const u2000AxiosNonAuthenticated = axios.create({
  baseURL: BASE_URL,
  headers: defaultHeaders,
  withCredentials: true,
});

export const u2000AxiosAuthenticated = axios.create({
  baseURL: BASE_URL,
  headers: defaultHeaders,
  withCredentials: true,
});

export interface U2000ParsedError {
  status: number;
  code: string;
  message: string;
  data: unknown;
}

export function U2000ParseResponseError(error: any): U2000ParsedError {
  return {
    status: error.response?.status ?? 0,
    code: error.code ?? "",
    message: error.message,
    data: error.response?.data,
  };
}

/** Entrée d'erreur API (réponse Axios brute ou objet parsé par l'intercepteur). */
export type U2000ApiErrorPayload = {
  errorCode?: string;
  parameters?: Array<{ name?: string; value?: string }>;
};

/** Lit la première erreur API (`errors[0]`) depuis une erreur Axios ou `U2000ParsedError`. */
export function U2000ExtractFirstApiError(error: unknown): U2000ApiErrorPayload | null {
  const err = error as {
    response?: { data?: { errors?: U2000ApiErrorPayload[] } };
    data?: { errors?: U2000ApiErrorPayload[] };
  };
  return err?.response?.data?.errors?.[0] ?? err?.data?.errors?.[0] ?? null;
}
